import { totalClicksConfig } from './../totalClicks';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerClicksConfig = {
    ...totalClicksConfig,
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
